/**
 * ROWIE — UGC heading reveal gate
 *
 * Reveals the "styled by you" heading only once the FourSixty feed has
 * actually rendered entries. The heading ships hidden, so a product with
 * no UGC never shows it at all — no flash of a heading that then
 * disappears.
 *
 * Scoped to .product-content rather than the whole document: the
 * standalone FourSixty section elsewhere on the page would otherwise
 * satisfy the check and reveal the in-column heading on a product with
 * no in-column content.
 */

(function () {
  var HEADING = '[data-rowie-ugc-heading]';
  var ENTRY = '.fs-entry-container';
  var DEADLINE_MS = 12000;

  function scopeFor(heading) {
    // The heading and the feed are siblings inside the content column,
    // not nested, so the shared ancestor is the scope.
    return heading.closest('.product-content') || document;
  }

  function countEntries(scope) {
    return scope.querySelectorAll(ENTRY).length;
  }

  function gate(heading) {
    if (heading.dataset.gated) return;
    heading.dataset.gated = '1';

    var scope = scopeFor(heading);
    var min = parseInt(heading.dataset.minEntries, 10) || 1;

    var reveal = function () {
      heading.hidden = false;
      // The content column may be sticky and height-aware.
      heading.dispatchEvent(
        new CustomEvent('product-content-height-change', { bubbles: true })
      );
    };

    // Already there — server-cached feed, or a re-init after the fact.
    if (countEntries(scope) >= min) {
      reveal();
      return;
    }

    var observer = new MutationObserver(function () {
      if (countEntries(scope) < min) return;
      observer.disconnect();
      clearTimeout(timer);
      reveal();
    });

    observer.observe(scope, { childList: true, subtree: true });

    // Stop watching eventually. A product with no UGC would otherwise
    // keep an observer alive on a large subtree for the life of the page.
    var timer = setTimeout(function () {
      observer.disconnect();
    }, DEADLINE_MS);
  }

  function initAll() {
    document.querySelectorAll(HEADING).forEach(gate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll(HEADING).forEach(function (el) {
      el.removeAttribute('data-gated');
    });
    initAll();
  });
})();